import { Label } from "@/components/ui/label";

/** Small label + content wrapper used across the Intake form. */
export default function Field({ label, children }) {
  return (
    <div>
      <Label className="text-xs uppercase tracking-wider text-stone-600 font-semibold">
        {label}
      </Label>
      <div className="mt-1.5">{children}</div>
    </div>
  );
}
